import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PageResponse } from '@core/shared/domain';

import { PlattformPackungseinheitMapping } from './industriekatalog';

@Injectable({ providedIn: 'root' })
export class PackungseinheitenMappingsService {
  private readonly baseApiPath = '/api/contentmanagement/platformpackagingmappings';

  constructor(private readonly httpClient: HttpClient) {}

  getAll(dataSource: string, params?: HttpParams): Observable<PageResponse<PlattformPackungseinheitMapping>> {
    return this.httpClient.get<PageResponse<PlattformPackungseinheitMapping>>(
      `${this.baseApiPath}/00000000-0000-0000-0000-000000000000/dataSource/${dataSource}`,
      { params },
    );
  }

  get(id: string, dataSource?: string, params?: HttpParams): Observable<PageResponse<PlattformPackungseinheitMapping>> {
    return this.httpClient.get<PageResponse<PlattformPackungseinheitMapping>>(
      `${this.baseApiPath}/${id}/dataSource/${dataSource}`,
      { params },
    );
  }

  update(einheit: PlattformPackungseinheitMapping): Observable<void> {
    return this.httpClient.put<void>(`${this.baseApiPath}`, einheit);
  }

  getDatenquellen(): Observable<PageResponse<string>> {
    return this.httpClient.get<PageResponse<string>>(`${this.baseApiPath}/datasources`);
  }
}
